import { render } from "./CountryList.vue?vue&type=template&id=5f0cfa64&ts=true"
import script from "./CountryList.vue?vue&type=script&lang=ts"
export * from "./CountryList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__